
/*
Defines the custom element <rss-card>
*/

import { RavelRSSCard } from './src/RavelRSSCard.js';

customElements.define('ravel-rss-card', RavelRSSCard);
